import styled from '@emotion/styled';
import { Select } from '@kc-console/common-ui';

const GnbSelect = styled(Select)`
  width: 100%;

  height: 48px;
  padding: 14px 12px;

  font-size: 13px !important;
  font-weight: 400;
  text-align: left;

  border-radius: 0;
  background-color: inherit;
  color: rgba(220, 225, 232, 1);

  svg {
    fill: rgba(220, 225, 232, 1);
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &:hover {
    background-color: ${({ theme }) =>
      theme.color['surface/global/transparent/strong/hover']} !important;
  }
  &:active {
    background-color: ${({ theme }) =>
      theme.color['surface/global/transparent/strong/press']} !important;
  }
  &.Mui-disabled {
    background-color: transparent;
    span {
      -webkit-text-fill-color: ${({ theme }) => theme.color['text/global/disabled']};
    }
    svg {
      fill: ${({ theme }) => theme.color['text/global/disabled']};
    }
  }
  &.Mui-focused {
    // Note : Select 에서 focusedVisible 처리가 가능한 별도의 방안 고려
    background-color: transparent;
  }
`;

export default GnbSelect as typeof Select;
